import { MODAL_SIZES, ModalHeader } from 'ui/modal';
import { isNull } from 'utils/tsHelpers';
import { useModalContext } from 'utils/contexts/modal';
import { useTranslation } from '../../../../../../hooks/useTranslation';
import { useSelectedHyperlink } from '../../hooks/useSelectedHyperlink';

export const Header = () => {
  const { hideModal } = useModalContext();
  const { t } = useTranslation();
  const selectedHyperlink = useSelectedHyperlink();

  return (
    <ModalHeader onClose={hideModal} size={MODAL_SIZES.MEDIUM}>
      {t(
        isNull(selectedHyperlink)
          ? 'contentPicker.textEditor.newHyperlinkModalTitle'
          : 'contentPicker.textEditor.editHyperlinkModalTitle',
      )}
    </ModalHeader>
  );
};
